module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get.a018e9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-manual-wizard/fullscreen-image_lets-get.png
// module id = 82fe
// module chunks = 0